import { makeActionCreator } from '../../config/store/utils'
import { getBuyerIndicators } from '../../services/buyers'
import { getBiddingMoreOffers, getBiddingLessOffers, getBiddingNullOffers } from '../../services/charts'

export const MAIN_INDICATORS = 'MAIN_INDICATORS'
export const MAIN_INDICATORS_ERROR = 'MAIN_INDICATORS_ERROR'
export const MAIN_INDICATORS_SUCCESS = 'MAIN_INDICATORS_SUCCESS'
export const onMainIndicators = makeActionCreator(MAIN_INDICATORS)
export const onMainIndicatorsError = makeActionCreator(MAIN_INDICATORS_ERROR, 'payload')
export const onMainIndicatorsSuccess = makeActionCreator(MAIN_INDICATORS_SUCCESS, 'payload')
export const onMainIndicatorsThunk = (year, idEntity) => async dispatch => {
  dispatch(onMainIndicators())

  try {
    const [licMasres, licMinres, licDesres] = await Promise.all([
      getBiddingMoreOffers({ idEntity, year }),
      getBiddingLessOffers({ idEntity, year }),
      getBiddingNullOffers({ idEntity, year })
    ])

    if (licMasres.data.success !== 'OK') {
      return dispatch(onMainIndicatorsError(licMasres.data.errores))
    }

    const licMasPayload = licMasres.data.payload.find(singleObj => singleObj.idEntity === parseInt(idEntity, 10))
    const licMinPayload = licMinres.data.payload.find(singleObj => singleObj.idEntity === parseInt(idEntity, 10))
    const licDesPayload = licDesres.data.payload.find(singleObj => singleObj.idEntity === parseInt(idEntity, 10))
    const payload = { licMas: licMasPayload || {}, licMin: licMinPayload || {}, licDes: licDesPayload || {} }

    return dispatch(onMainIndicatorsSuccess(payload))
  } catch (error) {
    return dispatch(onMainIndicatorsError(error))
  }
}

export const MAIN_INDICATORS_DETAILS = 'MAIN_INDICATORS_DETAILS'
export const MAIN_INDICATORS_DETAILS_ERROR = 'MAIN_INDICATORS_DETAILS_ERROR'
export const MAIN_INDICATORS_DETAILS_SUCCESS = 'MAIN_INDICATORS_DETAILS_SUCCESS'
export const onMainIndicatorDetails = makeActionCreator(MAIN_INDICATORS_DETAILS)
export const onMainIndicatorDetailsError = makeActionCreator(MAIN_INDICATORS_DETAILS_ERROR, 'payload')
export const onMainIndicatorDetailsSuccess = makeActionCreator(MAIN_INDICATORS_DETAILS_SUCCESS, 'payload')
export const onMainIndicatorDetailsThunk = payload => async dispatch => {
  dispatch(onMainIndicatorDetails())

  try {
    const response = await getBuyerIndicators({ id: payload.id, type: payload.type, year: payload.year })

    if (response.data.success !== 'OK') {
      return dispatch(onMainIndicatorDetailsError({ error: response.data.errores }))
    }

    const { payload: tableStructure } = response.data
    const csvStructure = [
      ['ID Licitación', 'Fecha de publicación', 'Categoría', 'N° de órdenes de compra asociadas'],
      ...tableStructure.map(item => [item.bidID, item.awardDate, item.description, item.offerNumbers])
    ]

    return dispatch(onMainIndicatorDetailsSuccess({ csvStructure, tableStructure }))
  } catch (error) {
    return dispatch(onMainIndicatorDetailsError({ error }))
  }
}
